export default function ClosingCTA() {
  const handleRequestInvitation = () => {
    window.REACT_APP_NAVIGATE('/pricing');
  };

  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        
        <div className="bg-gradient-to-br from-[#0F1F3D] to-[#1a3a6e] rounded-3xl p-12 lg:p-16 relative overflow-hidden">
          
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#4DB8D4]/10 rounded-full blur-3xl pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#4DB8D4]/10 rounded-full blur-3xl pointer-events-none"></div>

          <div className="relative space-y-6">
            <h2 className="text-3xl lg:text-5xl font-serif text-white leading-tight">
              Earn More —<br />Without More Clinic Hours
            </h2>
            
            <p className="text-lg lg:text-xl text-white/90 leading-relaxed max-w-2xl mx-auto">
              Vetuvia is building a platform for veterinarians who want more reach, more flexibility, and more ownership in how they serve.
            </p>

            <div className="pt-4">
              <button
                onClick={handleRequestInvitation}
                className="inline-flex items-center gap-3 bg-[#4DB8D4] hover:bg-[#3da5bb] text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <span className="text-base">Request Invitation</span>
                <i className="ri-arrow-right-line text-lg"></i>
              </button>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}
